import React from "react";
import {
  greeting,
  greetingDescription,
  githubUrl,
  linkedinUrl,
} from "../../../data/Data";

function Presentation() {
  return (
    <div className="presentation-section">
      <div className="presentation-div">
        <div>
          <h1>{greeting}</h1>
          <h3>{greetingDescription}</h3>
        </div>
        <div>
          <span>
            <a
              href={githubUrl}
              className="pres-icon"
              target="example"
              rel="noopener"
            >
              <i className="fab fa-github-square"></i>
            </a>
          </span>
          <span>
            <a
              href={linkedinUrl}
              className="pres-icon"
              target="example"
              rel="noopener"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Presentation;
